const title = {
    download: '文件中心'
}
export default title